import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './confirmation.css';

const Confirmation = () => {
    const [searchParams] = useSearchParams();
    const [meetingType, setMeetingType] = useState('meeting');

    useEffect(() => {
        // Extract meeting type from URL parameters
        const event = searchParams.get('event');
        if (event) {
            if (event.includes('zoom')) {
                setMeetingType('Zoom session');
            } else if (event.includes('in-person') || event.includes('christ-church')) {
                setMeetingType('in-person session');
            } else if (event.includes('intro')) {
                setMeetingType('introduction meeting');
            } else {
                setMeetingType('session');
            }
        }
    }, [searchParams]);

    return (
        <main className="confirmation">
            <div className="confirmation_content">
                <div className="confirmation_icon">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#87B5A3" strokeWidth="2"/>
                        <path d="m9 12 2 2 4-4" stroke="#87B5A3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                
                <h1 className="confirmation_title">Thank You!</h1>
                
                <div className="confirmation_message">
                    <p className="confirmation_text">
                        Your {meetingType} has been successfully scheduled. 
                        You should receive a confirmation email shortly with all the details.
                    </p>
                    
                    <div className="confirmation_details">
                        <h3>What happens next?</h3>
                        <ul>
                            <li>Check your email for the meeting confirmation and calendar invite</li>
                            <li>Add the meeting to your personal calendar</li>
                            <li>If it's a Zoom meeting, the link will be provided in the confirmation email</li>
                            <li>Feel free to prepare any questions you'd like to discuss</li>
                        </ul>
                    </div>
                </div>
                
                <div className="confirmation_actions">
                    <button 
                        className="confirmation_button confirmation_button--primary"
                        onClick={() => window.location.href = '/'}
                    >
                        Return to Home
                    </button>
                </div>
            </div>
        </main>
    );
};

export default Confirmation;
